import { useContext, useMemo } from "react";
import { useMutation } from "react-query";
import axios from "axios";
import { FormValues } from "../components/form";
import { ProductContext } from "../context/product";

interface DataLayerPageData {
  country: string;
  language: string;
  locale: string;
  path: string;
  primaryCategory: string;
  type: string;
}

const useSubmitForm = () => {
  const { activeProduct } = useContext(ProductContext);

  const pageData: DataLayerPageData = useMemo(() => {
    if (process.env.NODE_ENV === "development") {
      return {
        country: "en",
        language: "us",
        locale: "en-US",
        path: '"https://www.bose.com/en_us/products/headphones/noise_cancelling_headphones/quietcomfort-headphones-45.html"',
        primaryCategory: "headphones",
        type: "productpage",
      };
    }

    return (window as any).Bose.DataLayer.Data.Page;
  }, []);

  const mutation = useMutation(
    async ({
      yourFirstName,
      yourLastName,
      yourEmail,
      subscribeToMarketing,
      recipientFirstName,
      recipientLastName,
      recipientEmail,
      message,
    }: FormValues) => {
      if (subscribeToMarketing) {
        await axios("https://adobeprod-w.bose.com/bose/addSubscriber.jssp", {
          method: "POST",
          data: JSON.stringify({
            email: yourEmail,
            country: pageData.country.toUpperCase(),
            language: pageData.language,
            locale: `${pageData.language}_${pageData.country.toUpperCase()}`,
            productCode: activeProduct,
            label: "pxt_holidayhint_mothersday_22",
            mobile_device: (window as any)?.Gridle?.isActive("small") ?? false,
            subscribe_to_newsletter: subscribeToMarketing,
            add_to_visitor_table: false,
            firstName: yourFirstName,
            lastName: yourLastName,
          }),
        });
      }

      // Add to Visitor table
      await axios("https://adobeprod-w.bose.com/bose/holidayhint.jssp", {
        params: {
          email: yourEmail,
          firstName: yourFirstName,
          lastName: yourLastName,
          recipientFirstName: recipientFirstName,
          recipientLastName: recipientLastName,
          recipientEmail: recipientEmail,
          product: activeProduct,
          optin: subscribeToMarketing,
          recipientMessage: message,
        },
      });
    }
  );

  return mutation;
};

export default useSubmitForm;
